<template>
	<div class="info">
		<h3>ПРАВИЛА ПОДАЧИ.</h3>

		<ol>
			<li>
				<p>
					<b>ПРАВИЛЬНО ВЫБЕРИТЕ ТИП ОБЪЯВЛЕНИЯ.</b>
				</p>

				<p>
					От этого будет зависеть стоимость слова и начало времени суток выхода объявления.
				</p>

				<ul>
					<li>
						<p>
							<b>НЕКОММЕРЧЕСКИЕ ОБЪЯВЛЕНИЯ</b> выходят в рубриках «НЕДВИЖИМОСТЬ», «РАБОТА», «ТРАНСПОРТ»,
							«ЖИВОТНЫЙ
							МИР», «ПОТЕРИ», «СООБЩЕНИЯ».
						</p>

						<p>
							Текст НЕКОММЕРЧЕСКОГО ОБЪЯВЛЕНИЯ не содержит информации, связанной с предпринимательской
							деятельностью.
						</p>

						<p>
							Время начала суток может быть выбрано самостоятельно.
						</p>
					</li>
					<li>
						<p>
							<b>Объявления, связанные с получением прибыли, являются КОММЕРЧЕСКИМИ ОБЪЯВЛЕНИЯМИ.</b>
						</p>

						<p>
							! Особенность выхода в эфир: сутки выхода начинаются с 0:00, поэтому подача заранее - за
							один
							рабочий день.
						</p>
					</li>
				</ul>

			</li>
			<li>
				<p>
					<b>ВВЕДИТЕ ТЕКСТ ОБЪЯВЛЕНИЯ.</b>
				</p>

				<p>
					В тексте не забудьте указать контактный номер телефона.
				</p>

				<p>
					Чтобы телефон считался одним словом, он должен быть занесен в одном из следующих форматов:
				</p>

				<p class="color-red">
					"т.+7(999) 999-99-99", "Тел.:999-999", "Т.(9999) 999-999", "т.999-99-99"
				</p>

				<p class="color-red">
					С правилами подсчета слов можно ознакомиться здесь (ссылка).
				</p>

			</li>
			<li>
				<b>В КАЛЕНДАРЕ ВЫБЕРИТЕ ДАТЫ ВЫХОДА ОБЪЯВЛЕНИЯ.</b>
			</li>
		</ol>

		<h3>
			ПОРЯДОК ПОДАЧИ И ВЫХОДА НЕКОММЕРЧЕСКИХ ОБЪЯВЛЕНИЙ В ЭФИР.
		</h3>

		<p>
			Если объявление подано и оплачено <b>с понедельника по пятницу с 9:00 до 15:00 часов</b>, то оно может
			выйти в эфир <b>в течение 3-х часов этого же дня</b>.
		</p>

		<p>
			Если объявление подано и оплачено <b>с понедельника по четверг после 15:00 часов</b>, то объявление
			может выйти в эфир <b>после 12:00 часов следующего дня</b>.
		</p>

		<p>
			Если объявление подано и оплачено <b>после 15:00 часов пятницы до конца воскресного дня</b>, то
			объявление может выйти в эфир <b>в понедельник после 12:00 часов</b>.
		</p>

		<p>
			Объявления, поданные и оплаченные в праздничные дни, могут выйти в эфир <b>после 12:00 часов
			первого рабочего дня</b>.
		</p>
	</div>
</template>

<script>
	export default {
		name: "TheInfo"
	}
</script>

<style scoped>

</style>